import styled, { borderRadius, spacing } from "@rentiohq/web-theme";
import { Link } from "react-router-dom";

const CHAPTER_CARD_MIN_WIDTH = "280px";
const CHAPTER_COVER_HEIGHT = "160px";

export const ShortVersion = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing("base")};
  margin-bottom: ${spacing("extraLoose")};
  padding: ${spacing("loose")};
  border-radius: ${borderRadius("large")};
  background: ${({ theme }) => theme.getColor("primary", "0")};
  border: 1px solid ${({ theme }) => theme.getColor("primary", "200")};
`;

const START_NUMBER_SIZE = "32px";

export const Start = styled.div`
  margin-bottom: ${spacing("extraLoose")};
  padding: ${spacing("loose")};
  border-radius: ${borderRadius("large")};
  border: 1px solid ${({ theme }) => theme.colors.neutral30};
  background: ${({ theme }) => theme.colors.neutral0};
`;

export const StartSteps = styled.ol`
  display: flex;
  flex-direction: column;
  gap: ${spacing("base")};
  margin: ${spacing("base")} 0;
  padding: 0;
  list-style: none;
`;

export const StartStep = styled.li`
  display: flex;
  align-items: flex-start;
  gap: ${spacing("base")};
`;

export const StartNumber = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: ${START_NUMBER_SIZE};
  height: ${START_NUMBER_SIZE};
  border-radius: 50%;
  background: ${({ theme }) => theme.getColor("primary")};
  color: ${({ theme }) => theme.colors.neutral0};
  font-weight: 600;
`;

export const StartLinks = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${spacing("extraTight")} ${spacing("base")};
  margin-top: ${spacing("extraTight")};
`;

export const StartLink = styled(Link)`
  font-size: 14px;
  color: ${({ theme }) => theme.getColor("primary")};
`;

export const Search = styled.div`
  margin-bottom: ${spacing("loose")};
`;

export const Results = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing("tight")};
  margin-top: ${spacing("base")};
`;

export const Result = styled(Link)`
  display: block;
  padding: ${spacing("base")} ${spacing("loose")};
  border-radius: ${borderRadius("large")};
  border: 1px solid ${({ theme }) => theme.colors.neutral30};
  background: ${({ theme }) => theme.colors.neutral0};
  color: inherit;
  text-decoration: none;

  &:hover,
  &:focus-visible {
    border-color: ${({ theme }) => theme.getColor("primary")};
  }
`;

export const SectionTitle = styled.h2`
  margin: 0 0 ${spacing("extraTight")};
  font-size: 20px;
  color: ${({ theme }) => theme.colors.neutral100};
`;

export const ChapterGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(
    auto-fill,
    minmax(${CHAPTER_CARD_MIN_WIDTH}, 1fr)
  );
  gap: ${spacing("base")};
  margin-top: ${spacing("loose")};
`;

export const ChapterCard = styled(Link)`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: ${borderRadius("large")};
  border: 1px solid ${({ theme }) => theme.colors.neutral30};
  background: ${({ theme }) => theme.colors.neutral0};
  color: inherit;
  text-decoration: none;
  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease;

  &:hover,
  &:focus-visible {
    border-color: ${({ theme }) => theme.getColor("primary")};
    box-shadow: 0 2px 8px ${({ theme }) => theme.colors.neutral20};
  }
`;

// Screenshots are cut to one height, top first: that is where a screen says
// what it is.
export const ChapterCover = styled.img`
  display: block;
  width: 100%;
  height: ${CHAPTER_COVER_HEIGHT};
  object-fit: cover;
  object-position: top;
  border-bottom: 1px solid ${({ theme }) => theme.colors.neutral20};
  background: ${({ theme }) => theme.colors.neutral10};
`;

export const ChapterBody = styled.div`
  padding: ${spacing("loose")};
`;

export const ChapterCoverWrap = styled.div`
  position: relative;
`;

// Over the cover's top right corner, where it does not push the text down.
export const ChapterScore = styled.div`
  position: absolute;
  top: ${spacing("tight")};
  right: ${spacing("tight")};
`;

export const ChapterLabel = styled.div`
  margin-bottom: ${spacing("extraTight")};
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.getColor("primary")};
`;

export const CardTitle = styled.div`
  margin-bottom: ${spacing("extraTight")};
  font-size: 17px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.neutral100};
`;

export const CardText = styled.div`
  font-size: 14px;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.neutral80};
`;
